
function Scoreboard({ match, activeSet }) {
  if (!match || !match.player1 || !match.player2) return null;
  const player1 = match.player1;
  const player2 = match.player2;
  const sets = match.sets;
  const setscores = [
    { player1: 6, player2: 3 },
    { player1: 4, player2: 6 },
    { player1: 7, player2: 6 },
    { player1: 1, player2: 6 },
    { player1: 3, player2: 2 },
  ];
  // The set being actively coded/edited isn't always the last one in
  // match.sets (e.g. later sets can already exist while going back to finish
  // an earlier one) — prefer the caller-supplied active set for the game
  // score display, falling back to the last set only when none is given.
  const currentSet =
    activeSet ?? (sets && sets.length > 0 ? sets[sets.length - 1] : null);
  const gamescores = (sc, oppsc) => {
    if (currentSet && currentSet.isTiebreak) {
      return sc;
    } else {
      const gs = ["00", "15", "30", "40", "A"];
      if (sc >= 3) {
        if (sc > oppsc && oppsc >= 3) return "A";
        else return "40";
      } else return gs[sc];
    }
  };

  return (
    <>
      <div className="flex-col p-2 bg-base-content text-base-100">
        <div className="flex gap-1 -mt-1">
          <div
            className="w-20 font-medium text-xs"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {(player1.firstName ?? "").substring(0, 1) +
              ". " +
              (player1.lastName ?? "").toUpperCase()}
          </div>
          <div className="flex gap-1">
            {sets &&
              sets.map((set, index) => (
                <div key={index} className="font-bold text-xs text-center w-2">
                  {set.scores?.player1SetScore ?? 0}
                </div>
              ))}
          </div>
          <div className="flex-1 font-medium text-xs text-center w-8 ml-0">
            {currentSet &&
              gamescores(
                currentSet.scores?.player1GameScore ?? 0,
                currentSet.scores?.player2GameScore ?? 0
              )}
          </div>
        </div>
        <div className="flex gap-1">
          <div
            className="w-20 font-medium text-xs"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {(player2.firstName ?? "").substring(0, 1) +
              ". " +
              (player2.lastName ?? "").toUpperCase()}
          </div>
          <div className="flex gap-1">
            {sets &&
              sets.map((set, index) => (
                <div key={index} className="font-bold text-xs text-center w-2">
                  {set.scores?.player2SetScore ?? 0}
                </div>
              ))}
          </div>
          <div className="flex-1 font-medium text-xs text-center w-8 ml-0">
            {currentSet &&
              gamescores(
                currentSet.scores?.player2GameScore ?? 0,
                currentSet.scores?.player1GameScore ?? 0
              )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Scoreboard;
